import "./SearchResultArticle.scss";

import * as _ from "lodash";

import * as React from "react";
import createReactClass from "create-react-class";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import { withReactAdapter } from "shared/src/module-federation/withReactAdapter";
import { Well } from "react-bootstrap";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import { getIntlMixinForPhraseProject } from "shared/src/i18n/IntlRootMixin";
import { CartStore } from "../../../../stores/CartStore";
import StoreDataStore from "../../../../stores/StoreDataStore";

import ArticleCard from "./bundles/articlecard/ArticleCard";

import SearchResultArticleErrorBoundary from "./SearchResultArticleErrorBoundary";

import {
    getOffersMatchingQuery,
    createArticleCardRenderData,
    filterBundleSelectorForCustomer
} from "../../../../utils/articleUtils";
import { isAListPage } from "shared/src/utils/ListPageUtils";
import { ArticleSelectionListProps } from "shared/src/utils/ListPageUtils";
import SEARCH_RESULT_LAYOUT from "./SearchResultLayout";
import { SearchResultLayout } from "./SearchResultLayout";
import { ReplaceInfo } from "./bundles/ReplaceListItem";
import { Bundle } from "shared/src/types/articlesearch/Article";
import { ListDeleteFunction, ListDeleteTracking } from "shared/src/types/ListItemRenderData";
import { PageType } from "shared/src/types/PageType";
import { ZeroResultType } from "shared/src/types/ZeroResultType";
import { ShoppingCartPosition } from "shared/src/types/ShoppingCartPosition";
import { ListSetBundleDto } from "shared/src/types/ListSetBundleDto";
import { ReplacementKind } from "shared/src/tracking/Tracking";
import { RefluxAction } from "reflux";
import { trackBundleSelectorToggled } from "shared/src/utils/SearchTrackingUtil";
import { NewArticleCardWrapper } from "./bundles/articlecard/NewArticleCardWrapper";
import { ArticleRenderData } from "shared/src/types/RenderData";
import { getAllOfferIds, getBasketIdsForBundle } from "shared/src/utils/articleUtil";
import { createLookupMap } from "shared/src/utils/CreateLookupMapUtil";

type SearchResultArticleProps = {
    replace?: ReplaceInfo | null;
    item: ArticleRenderData;
    addButton?: any;
    listOfArticles?: any;
    recentlyOrdered?: boolean;
    recentlyOrderedDateString?: string;
    onList?: boolean;
    showOtherBundle?: boolean;
    originalBundle?: string | null;
    searchResultLayout?: SearchResultLayout;
    deprecated?: boolean;
    renderedDeprecatedArticle?: React.ReactNode;
    query?: string;
    inContainer?: boolean;
    setBundleAction?: RefluxAction<[ListSetBundleDto]>;
    deleteAction?: ListDeleteFunction;
    deleteTracking?: ListDeleteTracking;
    pageType: PageType;
    zeroResultType: ZeroResultType | undefined | null;
    tabIndex?: number;
    listPosition?: number;
    hideNonExistentBundle?: boolean;
    replacementKind?: ReplacementKind;
    articleSelectionListProps: ArticleSelectionListProps | undefined | null;
    solrScore: number | null | undefined;
    showEVAlternativesButtonWithModal?: boolean | null | undefined;
};

type State = {
    bettyBundleId: string;
    cartAmounts: {
        [x: string]: number | undefined | null;
    };
    cartPrices: {
        [x: string]: ShoppingCartPosition | undefined | null;
    };
    errorOccurred: boolean;
    nonExistentBundle: boolean;
    showAllBundles: boolean;
};

function pageTypeIsSuitableForNewArticleCard(pageType: PageType): boolean {
    const pageTypesWhitelistedForNewArticleCard: string[] = CountryUtil.getOptionalConfig()
        ?.pageTypesWhitelistedForNewArticleCard || ["CATEGORY", "PROMOTION", "SEARCH", "ZERO_RESULT"];
    return pageTypesWhitelistedForNewArticleCard.includes(pageType);
}

export class SearchResultArticleInternal extends React.Component<SearchResultArticleProps, State> {
    unsubscribe: () => void;

    constructor(props: SearchResultArticleProps) {
        super(props);
        this.state = Object.assign(this.calcState(props.item.selectedBundle, false, props), { errorOccurred: false });
        this.unsubscribe = CartStore.listen(this.handleShoppingCartUpdate);
    }

    componentWillUnmount() {
        if (typeof this.unsubscribe === "function") {
            this.unsubscribe();
        }
    }

    handleShoppingCartUpdate = () => {
        const basketArticleIds = _.values(this.props.item.bundles)
            .map(getBasketIdsForBundle)
            .reduce((ids, arr) => ids.concat(arr), []);
        const cartAmounts = createLookupMap(basketArticleIds, (id) => CartStore.getItemAmount(id));
        const cartPrices = createLookupMap(basketArticleIds, (id) => CartStore.getCartItemTotalNetPrice(id));
        this.setState({
            cartAmounts,
            cartPrices
        });
    };

    calcState(
        selectedId: string | undefined | null,
        showAllBundles: boolean,
        props: SearchResultArticleProps
    ): Pick<State, "bettyBundleId" | "cartAmounts" | "cartPrices" | "nonExistentBundle" | "showAllBundles"> {
        let nonExistentBundle = false;
        let bettyBundleId = selectedId;
        const selectedBundle = selectedId && props.item.bundles[selectedId];
        if (!selectedBundle || !bettyBundleId) {
            const sortedBundles = _.sortBy(_.keys(this.props.item.bundles));
            bettyBundleId = sortedBundles[0];
            nonExistentBundle = true;
        }
        const basketArticleIds = getBasketIdsForBundle(props.item.bundles[bettyBundleId]);
        const cartAmounts = createLookupMap(basketArticleIds, (id) => CartStore.getItemAmount(id));
        const cartPrices = createLookupMap(basketArticleIds, (id) => CartStore.getCartItemTotalNetPrice(id));
        return {
            bettyBundleId,
            cartAmounts,
            cartPrices,
            nonExistentBundle,
            showAllBundles
        };
    }

    // bundle selection handler
    onBundleSelected = (newBettyBundleId: string): false => {
        const oldBettyBundleId = this.props.originalBundle;
        const selectedIdData = this.calcState(newBettyBundleId, false, this.props);
        this.setState(selectedIdData, () => {
            if (this.props.setBundleAction) {
                if (!("readOnly" in this.props.item) || !this.props.item.readOnly || SessionStore.isEmployee()) {
                    const bundle = this.props.item.bundles[newBettyBundleId];
                    this.props.setBundleAction({
                        newBettyBundleId,
                        oldBettyBundleId,
                        newBundleId: bundle && bundle.bettyBundleId.bundleNumber,
                        listId: ("listId" in this.props.item && this.props.item.listId) || undefined
                    });
                }
            }
        });
        return false;
    };

    onToggleShowAllBundles = () => {
        const bundleListExpanded = !this.state.showAllBundles;
        const bettyVariantBundleIds: string[] = Object.keys(this.props.item.bundles);
        trackBundleSelectorToggled(
            bundleListExpanded,
            this.state.bettyBundleId,
            this.props.item.variantId.bettyVariantId,
            bettyVariantBundleIds,
            "click"
        );
        this.setState({ showAllBundles: bundleListExpanded });
    };

    componentWillReceiveProps(nextProps: SearchResultArticleProps) {
        if (!_.isEqual(this.props, nextProps)) {
            this.setState(this.calcState(nextProps.item.selectedBundle, false, nextProps));
        }
    }

    renderArticleCard(
        amountInBasket: number | undefined | null,
        priceInBasket: ShoppingCartPosition | undefined | null,
        bettyOfferId: string | undefined | null,
        bundleId: string,
        isFirstBundle: boolean,
        isLastBundle: boolean
    ) {
        const customerStoreId: string | undefined | null = SessionStore.getCustomerStore();
        if (!customerStoreId) {
            return null;
        }
        const articleCardRenderData = createArticleCardRenderData(
            this.props.item,
            SessionStore.isEmployee(),
            customerStoreId,
            {
                selectedBundleId: bundleId,
                bettyOfferId: bettyOfferId,
                originalBundleId: this.props.originalBundle
            },
            amountInBasket,
            priceInBasket,
            this.props.replacementKind
        );
        const searchResultLayout =
            this.props.searchResultLayout === SEARCH_RESULT_LAYOUT.GRID
                ? SEARCH_RESULT_LAYOUT.GRID
                : SEARCH_RESULT_LAYOUT.LIST;

        const isPageSuitableForNewArticleCard = pageTypeIsSuitableForNewArticleCard(this.props.pageType);

        return isPageSuitableForNewArticleCard ? (
            <NewArticleCardWrapper
                // Data to be rendered
                item={this.props.item}
                articleDeprecated={this.props.deprecated || false}
                replace={this.props.replace}
                nonExistentBundle={this.state.nonExistentBundle}
                // Config stuff
                dontShowUnitPriceForBundle={_.size(this.props.item.bundleSelector) <= 1}
                tabIndex={this.props.tabIndex}
                // For tracking purposes
                articleIds={articleCardRenderData.articleIds}
                pageType={this.props.pageType}
                zeroResultType={this.props.zeroResultType}
                inContainer={this.props.inContainer}
                recentlyOrdered={this.props.recentlyOrdered || false}
                recentlyOrderedDateString={this.props.recentlyOrderedDateString}
                listInformation={articleCardRenderData.listInformation}
                marketplace={articleCardRenderData.marketplace}
                trackingInfo={articleCardRenderData.trackingInfo}
                listPosition={this.props.listPosition}
                onList={this.props.onList || false}
                debugInfo={articleCardRenderData.debugInfo}
                ltrDebugInfo={articleCardRenderData.ltrDebugInfo}
                solrScore={this.props.solrScore}
            />
        ) : (
            <ArticleCard
                {...articleCardRenderData}
                searchResultLayout={searchResultLayout}
                cartEnabled={CartStore.isEnabled()}
                storeName={StoreDataStore.getCurrentStoreName()}
                amountInBasket={amountInBasket || null}
                priceInBasket={priceInBasket}
                listOfArticles={this.props.listOfArticles}
                BSonSelect={this.onBundleSelected}
                replace={this.props.replace}
                addButton={this.props.addButton}
                deleteAction={this.props.deleteAction}
                deleteTracking={this.props.deleteTracking}
                onList={this.props.onList || false}
                inContainer={this.props.inContainer}
                recentlyOrdered={this.props.recentlyOrdered || false}
                recentlyOrderedDateString={this.props.recentlyOrderedDateString}
                showOtherBundle={this.props.showOtherBundle || false}
                deprecated={this.props.deprecated || false}
                pageType={this.props.pageType}
                zeroResultType={this.props.zeroResultType}
                renderedDeprecatedArticle={this.props.renderedDeprecatedArticle}
                nonExistentBundle={this.state.nonExistentBundle}
                tabIndex={this.props.tabIndex}
                listPosition={this.props.listPosition}
                articleSelectionListProps={this.props.articleSelectionListProps}
                onShowBundles={isFirstBundle && isLastBundle ? this.onToggleShowAllBundles : undefined}
                onHideBundles={!isFirstBundle && isLastBundle ? this.onToggleShowAllBundles : undefined}
                solrScore={this.props.solrScore}
                showEVAlternativesButtonWithModal={this.props.showEVAlternativesButtonWithModal}
            />
        );
    }

    renderArticleCardsForOffersInBasketAndQuery(
        selectedBundle: Bundle,
        isFirstBundle: boolean,
        isLastBundle: boolean
    ): Array<React.ReactNode> {
        const bettyOfferIds = getAllOfferIds(selectedBundle);
        const bettyOfferIdsInCart = bettyOfferIds.filter((id) => id && !_.isNil(this.state.cartAmounts[id]));
        // Render all offers of the article that are in the basket
        const offersInBasket = bettyOfferIdsInCart.map((id) =>
            this.renderArticleCard(
                this.state.cartAmounts[id],
                this.state.cartPrices[id],
                id,
                selectedBundle.bettyBundleId.bettyBundleId,
                isFirstBundle,
                isLastBundle
            )
        );

        // Render the offer that matches the queried offerId if it isn't in the cart
        const queriedOffer = getOffersMatchingQuery(selectedBundle, this.props.query)
            .filter((id) => !_.includes(bettyOfferIdsInCart, id))
            .map((id) =>
                this.renderArticleCard(
                    this.state.cartAmounts[id],
                    this.state.cartPrices[id],
                    id,
                    selectedBundle.bettyBundleId.bettyBundleId,
                    isFirstBundle,
                    isLastBundle
                )
            );
        return queriedOffer.concat(offersInBasket);
    }

    render() {
        if (this.state.showAllBundles) {
            const sortedBundles = _.sortBy(
                _.keys(
                    SessionStore.isEmployee()
                        ? this.props.item.bundleSelector
                        : filterBundleSelectorForCustomer(this.props.item, SessionStore.getCustomerStore(), undefined)
                )
            );
            return sortedBundles.map((bundle, index) =>
                this.renderBundle(bundle, index === 0, index === sortedBundles.length - 1)
            );
        } else {
            return this.renderBundle(this.state.bettyBundleId, true, true);
        }
    }

    renderBundle(bundleId: string, isFirstBundle: boolean, isLastBundle: boolean) {
        const bundle = this.props.item.bundles[bundleId];
        if (this.props.hideNonExistentBundle && this.state.nonExistentBundle) {
            return null;
        }
        let articleCards = [] as React.ReactNode[];
        if (!isAListPage(this.props.pageType)) {
            articleCards = this.renderArticleCardsForOffersInBasketAndQuery(bundle, isFirstBundle, isLastBundle);
        }

        // If there is nothing in the cart and query, just render the preselected offer (or the non-marketplace bundle).
        if (articleCards.length === 0) {
            const basketId = bundle.selectedOffer ? bundle.selectedOffer : bundleId;
            articleCards.push(
                this.renderArticleCard(
                    this.state.cartAmounts[basketId],
                    this.state.cartPrices[basketId],
                    bundle.selectedOffer,
                    bundleId,
                    isFirstBundle,
                    isLastBundle
                )
            );
        }

        const isSelected = this.props.articleSelectionListProps && this.props.articleSelectionListProps.isSelected;
        return (
            <React.Fragment>
                {articleCards.map((articleCard, index) => {
                    if (this.props.inContainer) {
                        if (this.props.searchResultLayout === SEARCH_RESULT_LAYOUT.GRID) {
                            return <span key={"k-" + bundleId + "-" + index}>{articleCard}</span>;
                        }
                        return <span key={bundleId + "-" + index}>{articleCard}</span>;
                    } else {
                        return (
                            <span key={bundleId + "-" + index}>
                                <Well
                                    className={
                                        "well-sm" +
                                        (isSelected ? " mfcss_card-article-2-selected test-selected" : "") +
                                        (this.state.showAllBundles && !isFirstBundle ? " additional-bundle" : "")
                                    }>
                                    {articleCard}
                                </Well>
                            </span>
                        );
                    }
                })}
            </React.Fragment>
        );
    }
}

export const SearchResultArticle = createReactClass({
    mixins: [getIntlMixinForPhraseProject("EXPLORE")],

    render() {
        return (
            <SearchResultArticleErrorBoundary>
                <SearchResultArticleInternal {...this.props} />
            </SearchResultArticleErrorBoundary>
        );
    }
});
export default withReactAdapter(SearchResultArticle);
